module.exports = __webpack_public_path__ + "media/images/icon-instagram-ad8bc03d8301faea8320f2e5d27afab5.svg";